/**
 * React Router link with style variants such as 'primary' or 'btn'.
 * Accepts 'to' for navigation and optional onClick.
 */
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import React from "react";

type StyledLinkProps = React.ComponentPropsWithoutRef<typeof Link> & {
  variant?:
    | "primary"
    | "secondary"
    | "btn"
    | "cardbtn"
    | "navLinksMobile"
    | string;
};

interface LinkStyles {
  color?: string;
  textDecoration?: string;
  textTransform?: string;
  fontSize?: string;
  fontFamily?: string;
  padding?: string;
  borderRadius?: string;
  border?: string;
  backgroundColor?: string;
  width?: string;
  marginLeft?: string;
  textAlign?: string;
  marginTop?: string;
  marginBlock?: string;
}

const linkStyles: Record<string, LinkStyles> = {
  primary: {
    color: 'white',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontFamily: 'Candara',
  },
  secondary: {
    color: 'black',
    textDecoration: 'underline',
    textTransform: 'capitalize',
    fontSize: '12px',
    fontFamily: 'Arial',
  },
  btn: {
    padding: '4px 8px',
    color: 'white',
    textDecoration: 'none',
    fontFamily: 'Candara',
    fontSize: '14px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    backgroundColor: 'transparent',
    width: 'fit-content',
    marginLeft: '10px',
  },
  cardbtn: {
    backgroundColor: '#761540',
    color: 'white',
    borderRadius: '42px',
    padding: '0 24px',
    textDecoration: 'none',
    fontFamily: 'Candara',
    fontSize: '16px',
    width: '267px',
    textTransform: 'none',
    textAlign: 'center',
    marginLeft: '0',
    marginTop: '0',
  },
  navLinksMobile: {
    color: 'white',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontFamily: 'Candara',
    marginBlock: '10px',
  },
};

const getLinkStyles = (variant?: string): LinkStyles => {
  return linkStyles[variant || 'primary'] || linkStyles['primary'];
};

const StyledLink = styled(Link)<StyledLinkProps>`
  color: ${props => getLinkStyles(props.variant).color};
  text-decoration: ${props => getLinkStyles(props.variant).textDecoration};
  text-transform: ${props => getLinkStyles(props.variant).textTransform || 'none'};
  font-size: ${props => getLinkStyles(props.variant).fontSize};
  font-family: ${props => getLinkStyles(props.variant).fontFamily};
  padding: ${props => getLinkStyles(props.variant).padding || '0'};
  border-radius: ${props => getLinkStyles(props.variant).borderRadius || '0'};
  border: ${props => getLinkStyles(props.variant).border || 'none'};
  background-color: ${props => getLinkStyles(props.variant).backgroundColor || 'transparent'};
  width: ${props => getLinkStyles(props.variant).width || 'auto'};
  margin-left: ${props => getLinkStyles(props.variant).marginLeft || '0'};
  text-align: ${props => getLinkStyles(props.variant).textAlign || 'left'};
  margin-top: ${props => getLinkStyles(props.variant).marginTop || '0'};
  margin-block: ${props => getLinkStyles(props.variant).marginBlock || '0'};
`;

export default StyledLink;
